import React from 'react';
import { Helmet } from 'react-helmet-async';
import Page from 'Page';
import Box from 'libs/core-components/Box/Box';
import Heading from 'libs/core-components/Heading/Heading';
import Stack from 'libs/core-components/Stack/Stack';
import { Wordmark } from 'common/Branding/99designsByVP';
import SiteFooter from '@99designs/frontend-components/apps/global-nav/components/SiteFooter/SiteFooter';
import { useSite } from 'common/SiteContext';

interface LayoutProps {
    title: string;
    description?: string;
    children: React.ReactNode;
    heading?: string;
}

export function Layout({ title, description, children, heading }: LayoutProps) {
    const site = useSite();

    return (
        <Page title={title}>
            {description && (
                <Helmet>
                    <meta name="description" content={description} />
                </Helmet>
            )}
            <Box as="main" display="flex" flexDirection="column" flexGrow={1}>
                <Box
                    display="flex"
                    justifyContent="center"
                    padding={['halfGutter', 'gutter']}
                    flexGrow={1}
                >
                    <Box flexGrow={1} maxWidth="400px">
                        <Stack space="gutter">
                            <Box display="flex" justifyContent="center">
                                <a href="/" title={__('99designs by Vistaprint')}>
                                    <Wordmark />
                                </a>
                            </Box>
                            <Box
                                display="flex"
                                flexDirection="row"
                                alignItems="baseline"
                                justifyContent="stretch"
                            >
                                {heading && (
                                    <Heading appearanceLevel={1} accessibilityLevel={1} withDivider>
                                        {heading}
                                    </Heading>
                                )}
                            </Box>
                            {children}
                        </Stack>
                    </Box>
                </Box>
                <Box marginTop="space10" width="100%">
                    <SiteFooter isFocused site={site} />
                </Box>
            </Box>
        </Page>
    );
}
